import RulesDetails from 'components/pages/Settings/Automations/Rules/RulesDetails'
import Feedback from 'components/pages/Settings/Channels/Feedback/Feedback'
import SmsDetail from 'components/pages/Settings/Channels/Sms/SmsDetail'
import RolesDetails from 'components/pages/Settings/MyOrganization/Roles/RolesDetails'
import TeamsDetails from 'components/pages/Settings/MyOrganization/Teams/TeamsDetails'
import CustomerSatisfactionForm from 'components/pages/Settings/Productivity/CustomerSatisfaction/CustomerSatisfactionForm'
import TaskAutomationDetails from 'components/pages/Settings/Tasks/TaskAutomation/TaskAutomationDetails'
import TemplateDetails from 'components/pages/Settings/Tasks/Templates/TemplateDetails'
import {SETTINGS_INTEGRATIONS_PATH, SETTINGS_PATH} from 'constants/path'
import SettingsLayout from 'layouts/Settings.layout'

const integrationsRoutes = [
  {
    path: SETTINGS_PATH.INTEGRATIONS,
    children: [
      {
        index: true,
        handle: {title: 'Integrations'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/Integrations'),
      },
      {
        path: `${SETTINGS_INTEGRATIONS_PATH.SHOPIFY}`,
        handle: {title: 'Integrations Shopify'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/Shopify/Shopify'),
      },
      {
        path: `${SETTINGS_INTEGRATIONS_PATH.LIVECHAT}`,
        handle: {title: 'Integrations LiveChat'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/LiveChat/LiveChat'),
      },
      {
        path: `${SETTINGS_INTEGRATIONS_PATH.BIG_COMMERCE}`,
        handle: {title: 'Integrations BigCommerce'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/BigCommerce/BigCommerce'),
      },
      {
        path: `${SETTINGS_INTEGRATIONS_PATH.JIRA}`,
        handle: {title: 'Integrations Jira'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/Jira/Jira'),
      },
      {
        path: `${SETTINGS_INTEGRATIONS_PATH.GITHUB}`,
        handle: {title: 'Integrations Github'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/Github/Github'),
      },
      {
        path: `${SETTINGS_INTEGRATIONS_PATH.ASANA}`,
        handle: {title: 'Integrations Asana'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/Asana/Asana'),
      },
      {
        path: `${SETTINGS_INTEGRATIONS_PATH.CLICKUP}`,
        handle: {title: 'Integrations Clickup'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/Clickup/Clickup'),
      },
      {
        path: `${SETTINGS_INTEGRATIONS_PATH.TRELLO}`,
        handle: {title: 'Integrations Trello'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/Trello/Trello'),
      },
      {
        path: `${SETTINGS_INTEGRATIONS_PATH.MAGENTO}`,
        handle: {title: 'Integrations Magento'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/Magento/Magento'),
      },
      {
        path: `${SETTINGS_INTEGRATIONS_PATH.SLACK}`,
        handle: {title: 'Integrations Slack'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/Slack/Slack'),
      },
      {
        path: `${SETTINGS_INTEGRATIONS_PATH.INTERCOM}`,
        handle: {title: 'Integrations Intercom'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/Intercom/Intercom'),
      },
      {
        path: `${SETTINGS_INTEGRATIONS_PATH.DRIFT}`,
        handle: {title: 'Integrations Drift'},
        lazy: () => import('components/pages/Settings/Apps/Integrations/Drift/Drift'),
      },
    ],
  },
]

const settingsRoutes = [
  {
    path: 'settings',
    handle: {title: 'Settings'},
    element: <SettingsLayout />,
    children: [
      // My Settings
      {
        path: SETTINGS_PATH.MY_PROFILE,
        handle: {title: 'My Profile'},
        lazy: () => import('components/pages/Settings/MyProfile'),
      },
      // My Organization
      {
        path: SETTINGS_PATH.ACCOUNT_SETTINGS,
        handle: {title: 'Account Settings'},
        lazy: () => import('components/pages/Settings/MyOrganization/AccountSettings'),
      },
      {
        path: SETTINGS_PATH.USERS,
        handle: {title: 'Users'},
        lazy: () => import('components/pages/Settings/MyOrganization/Users/Users'),
      },
      {
        path: `${SETTINGS_PATH.USERS}/:id`,
        handle: {title: 'Users'},
        lazy: () => import('components/pages/Settings/MyOrganization/Users/UsersDetails'),
      },
      {
        path: SETTINGS_PATH.TEAMS,
        handle: {title: 'Teams'},
        lazy: () => import('components/pages/Settings/MyOrganization/Teams/Teams'),
      },
      {
        path: `${SETTINGS_PATH.TEAMS}/:id`,
        handle: {title: 'Teams'},
        element: <TeamsDetails />,
      },
      {
        path: SETTINGS_PATH.ROLES,
        handle: {title: 'Roles'},
        lazy: () => import('components/pages/Settings/MyOrganization/Roles/Roles'),
      },
      {
        path: `${SETTINGS_PATH.ROLES}/:roleId`,
        handle: {title: 'Roles'},
        element: <RolesDetails />,
      },
      {
        path: SETTINGS_PATH.NOTIFICATIONS,
        handle: {title: 'Notifications'},
        lazy: () => import('components/pages/Settings/MyOrganization/Notification'),
      },
      // Channels
      {
        path: SETTINGS_PATH.EMAIL,
        handle: {title: 'Email'},
        lazy: () => import('components/pages/Settings/Channels/EmailInbox/InboxTab'),
      },
      {
        path: `${SETTINGS_PATH.EMAIL}/:inboxId`,
        handle: {title: 'Email'},
        lazy: () => import('components/pages/Settings/Channels/EmailInbox/InboxEdit'),
      },
      {
        path: SETTINGS_PATH.SUPPORT_WIDGET,
        handle: {title: 'Support Widget'},
        lazy: () => import('components/pages/Settings/Channels/Widget/Widget'),
      },
      {
        path: SETTINGS_PATH.FACEBOOK,
        handle: {title: 'Facebook Messenger'},
        lazy: () => import('components/pages/Settings/Channels/Facebook/facebook'),
      },
      {
        path: `${SETTINGS_PATH.FACEBOOK}/:id`,
        handle: {title: 'Facebook'},
        lazy: () => import('components/pages/Settings/Channels/Facebook/FaceBookDetails'),
      },
      {
        path: SETTINGS_PATH.INSTAGRAM,
        handle: {title: 'Instagram'},
        lazy: () => import('components/pages/Settings/Channels/Instagram/Instagram'),
      },
      {
        path: `${SETTINGS_PATH.INSTAGRAM}/:id`,
        handle: {title: 'Instagram'},
        lazy: () => import('components/pages/Settings/Channels/Instagram/InstagramDetails'),
      },
      {
        path: SETTINGS_PATH.WHATSAPP,
        handle: {title: 'Whatsapp'},
        lazy: () => import('components/pages/Settings/Channels/Whatsapp/Whatsapp'),
      },
      {
        path: SETTINGS_PATH.CONTACT_FORM,
        handle: {title: 'Contact Forms'},
        lazy: () => import('components/pages/Settings/Channels/Feedback/FeedbactList'),
      },
      {
        path: `${SETTINGS_PATH.CONTACT_FORM}/:id`,
        handle: {title: 'Contact Form'},
        element: <Feedback />,
      },
      {
        path: SETTINGS_PATH.LIVE_CHAT,
        handle: {title: 'Live Chat'},
        lazy: () => import('components/pages/Settings/Channels/ChatInbox/ChatInbox'),
      },

      {
        path: SETTINGS_PATH.PHONE,
        handle: {title: 'Phone'},
        lazy: () => import('components/pages/Settings/Channels/Phone/Phone'),
      },
      {
        path: SETTINGS_PATH.SMS,
        handle: {title: 'SMS'},
        lazy: () => import('components/pages/Settings/Channels/Sms/Sms'),
      },
      {
        path: `${SETTINGS_PATH.SMS}/:inboxId`,
        handle: {title: 'SMS'},
        element: <SmsDetail />,
      },
      // Custom Fields
      {
        path: SETTINGS_PATH.CUSTOMERS,
        handle: {title: 'Customers'},
        lazy: () => import('components/pages/Settings/CustomFields/ContactField'),
      },
      // Automations
      {
        path: SETTINGS_PATH.ROUTING,
        handle: {title: 'Routing'},
        lazy: () => import('components/pages/Settings/Automations/Routing/Routing'),
      },
      {
        path: `${SETTINGS_PATH.ROUTING}/:id`,
        handle: {title: 'Routing'},
        lazy: () => import('components/pages/Settings/Automations/Routing/RoutingDetails'),
      },
      {
        path: SETTINGS_PATH.WORKFLOWS,
        handle: {title: 'Workflows'},
        lazy: () => import('components/pages/Settings/Automations/Rules/Rules'),
      },
      {
        path: `${SETTINGS_PATH.WORKFLOWS}/:id`,
        handle: {
          title: 'Workflow Details',
          feature_key: {
            category: 'workflowAutomation',
            type: 'advanceWorkflows',
          },
          fallbackRoute: `${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.WORKFLOWS}`,
        },
        element: <RulesDetails />,
      },
      {
        path: SETTINGS_PATH.BUSINESS_HOURS,
        handle: {title: 'Business Hours'},
        lazy: () => import('components/pages/Settings/Automations/BusinessHours/BusinessHours'),
      },
      {
        path: `${SETTINGS_PATH.BUSINESS_HOURS}/:id`,
        handle: {title: 'Business Hours'},
        lazy: () => import('components/pages/Settings/Automations/BusinessHours/BusinessHoursDetails'),
      },
      {
        path: SETTINGS_PATH.SLA_MANAGEMENT,
        handle: {title: 'SLA Management'},
        lazy: () => import('components/pages/Settings/Automations/Sla/Sla'),
      },
      {
        path: `${SETTINGS_PATH.SLA_MANAGEMENT}/:id`,
        handle: {
          title: 'SLA Management',
          feature_key: {
            category: 'workflowAutomation',
            type: 'slaManagement',
          },
          fallbackRoute: `${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.SLA_MANAGEMENT}`,
        },
        lazy: () => import('components/pages/Settings/Automations/Sla/SlaDetails'),
      },
      {
        path: SETTINGS_PATH.TIME_TRACKING,
        handle: {title: 'Time Tracking'},
        lazy: () => import('components/pages/Settings/Automations/TimeTracking/TimeTracking'),
      },
      // Productivity
      {
        path: SETTINGS_PATH.TAGS,
        handle: {title: 'Tags'},
        lazy: () => import('components/pages/Settings/Productivity/Tags'),
      },
      {
        path: SETTINGS_PATH.EMAIL_TEMPLATES,
        handle: {title: 'Email Templates'},
        lazy: () => import('components/pages/Settings/Productivity/CannedResponse/CannedResponse'),
      },
      {
        path: `${SETTINGS_PATH.EMAIL_TEMPLATES}/:id`,
        handle: {title: 'Email Templates'},
        lazy: () => import('components/pages/Settings/Productivity/CannedResponse/CannedResponseDetails'),
      },
      {
        path: SETTINGS_PATH.CUSTOMER_SATISFACTION,
        handle: {title: 'Customer Satisfaction'},
        lazy: () => import('components/pages/Settings/Productivity/CustomerSatisfaction/CustomerSatisfaction'),
      },
      {
        path: `${SETTINGS_PATH.CUSTOMER_SATISFACTION}/:id`,
        handle: {
          title: 'Customer Satisfaction',
          feature_key: {
            category: 'advanceFeatures',
            type: 'csatSurveys',
          },
          fallbackRoute: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.CUSTOMER_SATISFACTION}`,
        },
        element: <CustomerSatisfactionForm />,
      },
      {
        path: SETTINGS_PATH.AUDIT_LOGS,
        handle: {title: 'Audit Logs'},
        lazy: () => import('components/pages/Settings/Productivity/AuditLog'),
      },
      {
        path: SETTINGS_PATH.TASK_TEMPLATES,
        handle: {title: 'Task Templates'},
        lazy: () => import('components/pages/Settings/Tasks/Templates/Template'),
      },
      {
        path: `${SETTINGS_PATH.TASK_TEMPLATES}/:id`,
        handle: {
          title: 'Task Template',
          feature_key: {
            category: 'advanceFeatures',
            type: 'taskTemplatesAndAtomation',
          },
          fallbackRoute: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.TASK_TEMPLATES}`,
        },
        element: <TemplateDetails />,
      },
      {
        path: SETTINGS_PATH.TASK_AUTOMATION,
        handle: {title: 'Task Automation'},
        lazy: () => import('components/pages/Settings/Tasks/TaskAutomation/TaskAutomation'),
      },
      {
        path: `${SETTINGS_PATH.TASK_AUTOMATION}/:id`,
        handle: {
          title: 'Task Automation',
          feature_key: {
            category: 'advanceFeatures',
            type: 'taskTemplatesAndAtomation',
          },
          fallbackRoute: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.TASK_AUTOMATION}`,
        },
        element: <TaskAutomationDetails />,
      },
      // Billing
      {
        path: SETTINGS_PATH.MY_PLAN,
        handle: {title: 'My Plan'},
        lazy: () => import('components/pages/Settings/Billing/MyPlan/MyPlan'),
      },
      {
        path: SETTINGS_PATH.INVOICES,
        handle: {title: 'Invoices'},
        lazy: () => import('components/pages/Settings/Billing/Invoices/Invoices'),
      },
      {
        path: `${SETTINGS_PATH.INVOICES}/:invoiceId`,
        handle: {title: 'Invoices'},
        lazy: () => import('components/pages/Settings/Billing/Invoices/InvoiceDetail'),
      },
      // Apps
      {
        path: SETTINGS_PATH.DEVELOPER_API,
        handle: {title: 'Developer API'},
        lazy: () => import('components/pages/Settings/Apps/DeveloperApi'),
      },
      ...integrationsRoutes,
      // Help
      {
        path: SETTINGS_PATH.KEYBOARD_SHORTCUTS,
        handle: {title: 'Keyboard Shortcuts'},
        lazy: () => import('components/pages/Settings/Help/KeyboardShortcuts'),
      },
    ],
  },
]

export default settingsRoutes
